import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import * as React from 'react';
import { Provider } from 'react-redux';

import { TReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { PageContainer } from '../Page';
import { HeaderContainer } from '../HeaderContainer';
import { ApplicationContext } from '../../utils/applicationContext';
import { NewReviewModalContainer } from '../NewReviewModal';
import { NewAnswerModalContainer } from '../NewAnswerModal';
import { NewQuestionModalContainer } from '../NewQuestionModal';
import { getReviewsConfig } from '../../utils/getReviewsConfig/getReviewsConfig';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { userAgent },
  } = context;

  const reviewsConfig = getReviewsConfig();

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={uaToDeviceType(userAgent || undefined)}>
          <Provider store={reduxStore}>
            <HeaderContainer />
            <PageContainer />
            <NewAnswerModalContainer />
            {reviewsConfig.SHOW_NEW_REVIEWS_MODAL && <NewReviewModalContainer />}
            {reviewsConfig.SHOW_NEW_QUESTION_MODAL && <NewQuestionModalContainer />}
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
